module.exports = __webpack_public_path__ + "img/header.feb69ebd.jpg";